// extracted by mini-css-extract-plugin
export default {"forgottenPasswordButton":"ForgottenPassword_forgottenPasswordButton__3e88r","forgottenPasswordSecondaryButton":"ForgottenPassword_forgottenPasswordSecondaryButton__y7yWE"};